import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderTextarea from '../../../../../common/components/render-input/text-area';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 9',
    eventLabel: 'Set Goals'
};

export const formName = Routes.STEPNINE;

export const formDetails = {
    key: 'myGoals',
    title: 'My Goals',
    formName,
    totalKey: 'myGoals',
    fields: {
        spending: {
            label: 'Spending',
            placeholder: 'I will spend...',
            required: false
        },
        saving: {
            label: 'Saving',
            placeholder: 'I will save...',
            required: false
        },
        debt: {
            label: 'Debt',
            placeholder: 'I will repay...',
            required: false
        },
        investments: {
            label: 'Investments',
            placeholder: 'I will invest...',
            required: false
        },
        other: {
            label: 'Other',
            placeholder: 'I will also...',
            required: false
        }
    }
};


const minValue = '';

const validate = values => v(values,
    Object.entries(formDetails.fields).reduce((obj, [ key, field ]) => ({
        ...obj,
        [key]: {
            presence: {
                allowEmpty: !field.required,
                message: 'is required'
            }
        }
    }), {})
);

class StepNineForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key =>
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            component={RenderTextarea}
                            required={formDetails.fields[key].required}
                            placeholder={formDetails.fields[key].placeholder}
                        />
                    )
                }
            </form>
        );
    }
}

const formValues = getFormValues(formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepNineForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.SUMMARY}`,
    tracking: () => trackingEvent(tracking)
})(StepNineForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepNineForm));
